import { NotifyHelper } from "../../../helpers/toast";
import { eDiemKyHieuActionsObj } from "../../action-types/category/IDiemKyHieuActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const diemKyHieuActions = {
    ...generateActions(eDiemKyHieuActionsObj, "DIEM_KY_HIEU"),
    ...generateActionForKey(eDiemKyHieuActionsObj, "DIEM_KY_HIEU", "SAVE_SUCCESS", () => {NotifyHelper.Success("Thành công")}),
    ...generateActionForKey(eDiemKyHieuActionsObj, "DIEM_KY_HIEU", "DELETE_SUCCESS", () => {NotifyHelper.Success("Thành công")}),
    ...generateActionForKey(eDiemKyHieuActionsObj, "DIEM_KY_HIEU", "SAVE_ERROR", (m) => {NotifyHelper.Error(m)}),
    ...generateActionForKey(eDiemKyHieuActionsObj, "DIEM_KY_HIEU", "DELETE_ERROR", (m) => {NotifyHelper.Error(m)}),
}